import { EnvironmentProviders } from '@angular/core';
import { userInitializerProvider } from './user.provider';
import { iconInitializerProvider } from '@app/utils/providers/icon.provider';

export const appInitializer: EnvironmentProviders[] = [userInitializerProvider, iconInitializerProvider];
